import React from 'react';
import InfoCard from 'src/components/InfoCard';
import SimpleInput from 'src/components/SimpleInput';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import TextButton from 'src/components/TextButton';
import SimpleSelect from 'src/components/SimpleSelect';
import PropTypes from 'prop-types';
import {
  IntentArgumentActions,
  IntentArgumentTypeContent,
  IntentBlock,
  IntentField,
  IntentFieldGroup
} from '../style';
import { getDefaultHeaderData } from '../Variation/utils';
import { automationMethodOptions } from '../constants';

export default function Automation({ handleChangeAutomation, url, method, headers }) {
  return (
    <IntentBlock>
      <div>
        <p>Automation (Optional)</p>
        <InfoCard>External service to send the collected information to.</InfoCard>
        <div>
          <IntentFieldGroup>
            <IntentField>
              <p>API URL</p>
              <SimpleInput
                value={url}
                onChange={e => handleChangeAutomation({ url: e.target.value })}
                placeholder="URL for the API"
              />
            </IntentField>
            <IntentField>
              <p>
                Method &nbsp; <span>(Optional)</span>
              </p>
              <SimpleSelect
                isDisabled
                value={method}
                options={[automationMethodOptions[0]]}
                onChange={value => handleChangeAutomation({ method: value })}
                placeholder="Method for the API"
              />
            </IntentField>
            <IntentField alignItems="flex-start">
              <p>
                Headers &nbsp; <span>(Optional)</span>
              </p>
              <IntentArgumentTypeContent>
                {headers?.map(header => (
                  <div key={header.id}>
                    <SimpleInput
                      value={header.key}
                      onChange={e => {
                        handleChangeAutomation({
                          headers: headers.map(el =>
                            el.id === header.id ? { ...header, key: e.target.value } : el
                          )
                        });
                      }}
                      placeholder="Key of the header"
                    />
                    <SimpleInput
                      value={header.value}
                      onChange={e => {
                        handleChangeAutomation({
                          headers: headers.map(el =>
                            el.id === header.id ? { ...header, value: e.target.value } : el
                          )
                        });
                      }}
                      placeholder="Value of the header"
                    />
                    <IntentArgumentActions>
                      <button
                        type="button"
                        onClick={() => {
                          handleChangeAutomation({
                            headers: headers.filter(el => el.id !== header.id)
                          });
                        }}
                      >
                        <FiTrash2 />
                      </button>
                    </IntentArgumentActions>
                  </div>
                ))}
                <TextButton
                  onClick={() => {
                    handleChangeAutomation({
                      headers: [...headers, getDefaultHeaderData()]
                    });
                  }}
                  type="button"
                >
                  <FiPlus /> Add header
                </TextButton>
              </IntentArgumentTypeContent>
            </IntentField>
          </IntentFieldGroup>
        </div>
      </div>
    </IntentBlock>
  );
}

Automation.propTypes = {
  handleChangeAutomation: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  method: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  headers: PropTypes.arrayOf(PropTypes.any)
};

Automation.defaultProps = {
  headers: []
};
